import { CompanyUser_BASE, ICompanyUser_Field, ICompanyUser_Key, ICompanyUser_Insert } from './base/CompanyUser.base';
import {Injectable} from '@angular/core';
import {PersistentService, AgaveService, CadmoBetweenRange, CadmoOperator} from 'tq-agave';



export class CompanyUser extends CompanyUser_BASE {
    // i fields servono per cose come la cadmo-table e cadmo-form-field
    // Nelle nuove versioni di typescript vengono ereditati anche i campi statici
    // static fieldList = CompanyUser_BASE.fieldList;
    // static keyList: string[] = CompanyUser_BASE.keyList;
    // static updateFieldList: string[] = CompanyUser_BASE.updateFieldList;

    constructor(value?: any) { super(value); }

    between_created_on_utc?: CadmoBetweenRange;
    between_modified_on_utc?: CadmoBetweenRange;
    override getCadmoOperators(): any {
        const operators = super.getCadmoOperators();
        // Metti qui sotto gli operatori custom
        if (this.between_created_on_utc?.start || this.between_created_on_utc?.stop) {
            operators['_operator_created_on_utc'] = CadmoOperator.BETWEEN;
            const {start, stop} = this.between_created_on_utc;
            operators['_startvalue_created_on_utc'] = start ? '' + AgaveService.getEpochFromDate(start) : undefined;
            operators['_stopvalue_created_on_utc'] = stop ? '' + AgaveService.getEpochFromDate(stop) : undefined;
        }
        if (this.between_modified_on_utc?.start || this.between_modified_on_utc?.stop) {
            operators['_operator_modified_on_utc'] = CadmoOperator.BETWEEN;
            const {start, stop} = this.between_modified_on_utc;
            operators['_startvalue_modified_on_utc'] = start ? '' + AgaveService.getEpochFromDate(start) : undefined;
            operators['_stopvalue_modified_on_utc'] = stop ? '' + AgaveService.getEpochFromDate(stop) : undefined;
        }
        return operators;
    }

    override getCadmoInsertAction(): string {
        return 'json_rpc_create_user';
    }

    override getCadmoModifyAction(): string {
        return 'json_rpc_modify_user';
    }

    override getCadmoDeleteAction(): string {
        return 'json_rpc_delete_user';
    }

}

export type ICompanyUser = CompanyUser & ICompanyUser_Field;

// Nota bene: se si tratta di una vista che ha una chiave primaria, puoi anche sostituire le interfacce nel generic con dei tipi piu' consoni
@Injectable({ providedIn: 'root' })
export class CompanyUserService extends PersistentService<CompanyUser, ICompanyUser_Field, ICompanyUser_Key, ICompanyUser_Insert> {
    constructor(agaveService: AgaveService) { super(CompanyUser, agaveService); }
        getUserNumber(companyId: string | null | undefined) {
            const proto = new CompanyUser();
            if(companyId && companyId !== '') {
                proto.company_id = companyId;
            }
            return this.count(proto);
        }
}

